/**
 * The resources that derive from IGraphTaskCreationResource contain information about
 * the origin of the plannerTask.
 */ /**
 * Possible values for Graph TaskCreation.creationSourceKind
 */ export var TaskCreationSourceKind = /*#__PURE__*/ function(TaskCreationSourceKind) {
    /** External creation source */ TaskCreationSourceKind["External"] = "external";
    /** Publication creation source */ TaskCreationSourceKind["Publication"] = "publication";
    return TaskCreationSourceKind;
}({});
